import Blog from "../../layouts/Blog";
import "../../styles/Blog.css"
import hljs from 'highlight.js';
import 'highlight.js/styles/dark.css';
import {useEffect} from "react";
import IconText from "../../components/IconText";
import {faAsterisk, faHandPointUp, faPlay, faSquareRootVariable} from "@fortawesome/free-solid-svg-icons";
import DataTypes from "../../components/blog/mathematicalArtificialIntelligence/DataTypes";
import DataScience from "../../components/blog/mathematicalArtificialIntelligence/DataScience";
import MachineLearning from "../../components/blog/mathematicalArtificialIntelligence/MachineLearning";
import Basics from "../../components/blog/mathematicalArtificialIntelligence/Basics";
import Calculus from "../../components/blog/mathematicalArtificialIntelligence/Calculus";
import Algebra from "../../components/blog/mathematicalArtificialIntelligence/Algebra";
import DiscreteMathematics from "../../components/blog/mathematicalArtificialIntelligence/DiscreteMathematics";
import ProbabilityTheory from "../../components/blog/mathematicalArtificialIntelligence/ProbabilityTheory";
import Statistics from "../../components/blog/mathematicalArtificialIntelligence/Statistics";
import References from "../../components/blog/mathematicalArtificialIntelligence/References";

export default function MathematicalArtificialIntelligence() {
    useEffect(() => {
        hljs.highlightAll();
    }, []);

    const rightContent = (
        <div>
            <h1>
                <IconText text={"Mathematical Artificial Intelligence"}
                          bgColor={true}/>
            </h1>
            <div className={"blog-abstract"}>
                <p>
                    The
                    principles of artificial
                    intelligence are rooted in mathematical knowledge developed over centuries, from fundamental
                    geometry to
                    discrete mathematics. A strong grasp of these concepts is essential to truly appreciate how machine
                    learning
                    algorithms function.
                </p>
            </div>

            <div className={"blog-body"}>
                <h1><IconText icon={faPlay} text={"Introduction"}/></h1>
                <p>Especially in the last decade, we become more familiar with the terms artificial intelligence,
                    machine learning and data science. Powerful computers allowed us to perform more complex statistical
                    operations, from personalizing internet advertisements for each user to finding out who was the best
                    general in military history (Arsht, 2019). It is important to clarify these buzzwords before diving
                    into mathematical concepts to inform reader about this work of field.</p>
            </div>
            
            <DataTypes/>
            
            <DataScience/>
            
            <MachineLearning/>

            <div className={"blog-body"}>
                <h1><IconText icon={faSquareRootVariable} text={"Mathematics"}/></h1>
                <p>When one speaks of artificial intelligence, one first thinks of probability, statistics and
                    information theory, but that is not all. Behind artificial intelligence lies valuable knowledge
                    gathered over millennia. From basic geometry to discrete mathematics, a significant amount of
                    mathematical knowledge is required to understand how machine learning algorithms work. Today, the
                    range of applications for artificial intelligence is immense. It is a predictive tool in the
                    simplest sense and can be used in any field that requires prediction. With this mathematical
                    knowledge, machine learning models can be developed into even more powerful tools, leading to an
                    acceleration of human development. The main inspiration for this section is the article AI &
                    Mathematics by Shafi (Shafi, 2020).</p>
            </div>
            
            <Basics/>
            
            <Calculus/>
            
            <Algebra/>
            
            <DiscreteMathematics/>
            
            <ProbabilityTheory/>
            
            <Statistics/>

            <div className={"blog-body"}>
                <h1><IconText icon={faHandPointUp} text={"Conclusion"}/></h1>
                <p>Artificial intelligence is a subfield of data science and closely related to statistics. Artificial
                    intelligence algorithms learn, in a sense, by optimizing themselves with respect to the goal to be
                    achieved, and the trained models are used to make predictions. It is not surprising that artificial
                    intelligence is now appearing in every field where predictions are made. This field, which is
                    growing in popularity, continues to fascinate us with its findings.</p>
                <p>
                    The information obtained in this study not only provides a foundation for machine learning, but may
                    also lead to the discovery of new methods. It is difficult to predict what the future will bring,
                    but given the rapid pace of recent developments, it is obvious that we will see many more exciting
                    innovations. The most important thing is that we use them for the benefit of humanity.</p>
            </div>

            <div className={"blog-body"}>
                <h1><IconText icon={faAsterisk} text={"References"}/></h1>
            </div>
            
            <References/>

        </div>
    )

    return (
        <div className="google-foobar-challange-page">
            <Blog rightContent={rightContent}/>
        </div>
    )
}
